export class RegexPatterns {
  static SRB_MOBILE_NUMBER_PATTERN: string = '^\\+381\\d{8,9}';
  static CH_MOBILE_NUMBER_PATTERN: string = '^\\+41\\d{9}';
}
